import { executeRequest, Request } from '@jfs/network'
import { getRandomAlphaNumString } from '@jfs/utils'
import { Config } from 'react-native-config'
import { RootStore } from '../data/store'
import { Routes } from '../nav/routes'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

export interface CreateOrderInput {
  billerMasterId: number
  authenticators: Array<string>
  ebppBillerMasterId: number
  customerBillDataId: number
  customerBillerAccountId: number
  shortName: string
  billNumber: string
  billDate: string
  billAmount: string
  billDueDate: string
  debitType: string
  paymentMode: string
  customerAccountId: string
  customerEmail?: string
  payAmount?: string
  agentFeeAmount?: string
  beneficiaryId: number
}

const responseParser = (data: any, tokens: any) => {
  const orderData = data?.responseObj?.order
  const pgMetaData = data?.responseObj?.metaData
  let netAmount: any = orderData?.payment?.amountDetails?.netAmount
  // const { order, payload, merchant, intentId, returnUrl } = orderData
  const retData = {
    orderId: orderData?.id,
    txnRefNo: orderData?.payment?.id,
    myjioToken: '', //TODO: Confirm
    paymentAmount: netAmount,
    customerBillerAccountId: orderData?.customerDetails?.jfsUserId,
    partnerCode: orderData?.partner?.code,
    merchant: {},
    intentId: '',
    returnUrl: '',
  }

  const sessionData = RootStore?.user?.session ?? {}
  const UserInfoData = RootStore?.user ?? {}

  //netAmount = amountDecimalCorrection(netAmount)
  const saveDataToLocalStorage = {
    userMobileNo: UserInfoData?.mobile ?? '',
    appIdToken: sessionData?.appIdToken ?? '',
    appAccessToken: sessionData?.appAccessToken ?? '',
    userIdToken: sessionData?.userIdToken ?? '',
    userAccessToken: sessionData?.userAccessToken,
    userRefreshToken: sessionData?.refreshToken ?? '',
    appRefreshToken: sessionData?.appRefreshToken ?? '',
    orderId: orderData?.id ?? '',
    amount: netAmount,
  }
  //const orderDataString = JSON.stringify(saveDataToLocalStorage)
  //console.log('orderData', saveDataToLocalStorage, orderDataString)
  //window.localStorage.setItem('orderData', orderDataString)
  //storeData('orderData', saveDataToLocalStorage)

  //const redirectionUrl = pgMetaData?.redirectionUrl
  // TODO: pg app redirection from here
  // sessionSet(redirectionToPg, 'true')
  // formPost(pgData, redirectionUrl)

  return { response: retData, pgMetaData: pgMetaData }
}

// TODO: validate the redirect url for mobile app
const APP_URL = Config.REACT_APP_JFS_BASE_URL

export const createOrder = (tokens: any, userAccessToken: any, values: CreateOrderInput, form: any) => {
  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      orderType: 'BUY',
      description: 'This is for the buy case.',
    },
    //CONFIRM WITH BACKEND
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
      returnUrl: APP_URL + '/' + Routes.TXN_STATUS, //TODO: confirm return url for mobile app
      callbackUrl: '',
    },
    headerConfig: {
      ver: 1.0,
      ts: 'null',
      traceId: getRandomAlphaNumString(16) ?? '' ?? {},
      origInstId: 'abdc',
    },
    product: {
      id: values?.billerMasterId,
      attribute: {
        authenticatorList: values?.authenticators,
      },
    },
    bill: {
      number: values?.billNumber,
      amountDetails: {
        netAmount: values?.billAmount,
      },
    },
    payment: {
      amountDetails: {
        netAmount: values?.payAmount?.toString(),
      },
    },
    // customer: {
    //   jfsUserId: values?.customerAccountId,
    // },
    beneficiary: {
      id: values?.beneficiaryId,
      nickName: values?.shortName,
    },
    agent: {
      merchantId: form.merchantId,
      feeInfo: {
        amount: values?.agentFeeAmount,
        isIncludePayAmt: 'N',
      },
      customerInfo: {
        name: form.name,
        narration: 'cusotmerInfo',
        mobile: form.mobileNumber,
        email: values.customerEmail,
      },
      paymentCollectionMode: form.modeOfPayment,
    },
  }

  const config = sitConfig(tokens)
  const request: Request<{}> = {
    apiPath: APIEndPoints.createOrder,
    method: 'POST',
    config: config,
    body: requestBody,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    //headers: IS_DEVELOPMENT_MODE ? defaultHeader : getHeader(),
  }

  return executeRequest(request).then((response) => {
    const res = response?.data
    if (res?.responseStatus?.code === '000' || res?.status === 'SUCCESS') {
      // console.log('executeRequest', res?.responseObj)
      return responseParser(res, tokens)
    }
    const errorMsg = {
      errorCode: response?.data?.error?.code,
      errorMessage: response?.data?.error?.message,
    }
    throw errorMsg
  })
}

export const redirectPgFn = (req: any) => {
  return null
}
